class FormattingRuleScale {
    id: number;
    name: string;
    color: string;
    minValue: number;
    startValue: number;
    endValue: number;
    icon: string;
    backgroundColor: string;
    fontColor: string;

    constructor(formattingRule: FormattingRule, data) {
        this.id = data?.id ?? 0;
        this.name = data?.name ?? "";
        this.color = data?.color ?? "";
        this.minValue = data?.minValue ?? 0;
        this.startValue = data?.startValue ?? 0;
        this.endValue = data?.endValue ?? 0;
        this.icon = data?.icon ?? "square-fill";
        this.backgroundColor = data?.backgroundColor ?? "";
        this.fontColor = data?.fontColor ?? "";

        if (this.id === 0 && formattingRule?.scales) {
            for (let scale of formattingRule.scales) {
                if (this.id < scale.id)
                    this.id = scale.id;
            }

            this.id++;
        }
    }
}